export default __webpack_public_path__ + "static/Cinzel-Bold-539cec8922d2d5ee41a2f7530729b2d1.woff";